<template>
  <div class="sys-ft">
    <div class="sys-main">
      <div class="sys-ft-left-wp">
        <div class="sys-ft-intro sys-ft-intro-PC">
          <h2>加入柚米云平台</h2>
          <p>与柚米云一起创造边缘智能计算的未来</p>
          <a class="btn-box">立即加入</a>
        </div>
        <ul class="sys-footer-codebox" style="display: none">
          <li class="codebox-PC">
            <img src="@/assets/images/footer/gzh.png" alt="" />
            <p>柚米云公众号</p>
          </li>
          <li class="codebox-PC">
            <img src="@/assets/images/footer/dyh.png" alt="" />
            <p>柚米云抖音号</p>
          </li>
          <li class="codebox-H5">
            <img src="@/assets/images/footer/gzh.png" alt="" />
            <p class="codebox-H5-p-black">柚米云公众号</p>
            <p>保存二维码关注</p>
          </li>
          <li class="codebox-H5">
            <img src="@/assets/images/footer/dyh.png" alt="" />
            <p class="codebox-H5-p-black">柚米云抖音号</p>
            <p>保存二维码关注</p>
          </li>
        </ul>
      </div>
      <div class="sys-ft-info">
        <div class="sys-ft-intro sys-ft-intro-H5">
          <h2>加入柚米云平台</h2>
          <p>与柚米云一起创造边缘智能计算的未来</p>
          <a class="btn-box">立即加入</a>
        </div>
        <div class="sys-ft-nav-wp">
          <img class="logo" src="@/assets/logo.png" alt="" />
          <dl>
            <dt>服务支持</dt>
            <dd>
              <a @click="getRouter('/download-app')">柚米云APP下载</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section4')">常见问题</a>
            </dd>
          </dl>
          <dl>
            <dt>解决方案</dt>
            <dd>
              <a @click.prevent="goSolution(0)">音视频解决方案</a>
            </dd>
            <dd>
              <a @click.prevent="goSolution(1)">云安全解决方案</a>
            </dd>
            <dd>
              <a @click.prevent="goSolution(2)">云游戏解决方案</a>
            </dd>
            <dd>
              <a @click.prevent="goSolution(3)">云渲染解决方案</a>
            </dd>
          </dl>
          <dl>
            <dt>友情合作</dt>
            <dd>
              <a @click.prevent="getRouter('/#section3')">柚米科技</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section3')">商务合作</a>
            </dd>
          </dl>
          <dl>
            <dt>探索柚米</dt>
            <dd>
              <a @click.prevent="getRouter('/#section3')">加入我们</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section3')">关于我们</a>
            </dd>
          </dl>
        </div>
      </div>
      <div class="sys-ft-rights">
        <div style="text-align: center">
          <a href="#" class="first-beian">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAC3FBMVEUAAAD+/ODz6Kr//+PeqFfYrn3x167k0JXoxnyaaVzhs2ifaFXbrGLkvFnpyF7v2X/kwm3cp1nhsGfqw3rZqG3ntVzjrFPt3oDjvGnfr2fbnFGti3q0lH7ktoLryXn9v1T4znr/74bnvGz034v+2I/ktoDz6ZLkwY/Dfz7buoftzYbq2IPr0pjs3bLv6KPRrnbKhFv79ND488n/+dDZr4Lx38f/+cH/95f42oL7/97s2Y3++uzw1rvTk3DmuloAAHkBAm7uzWYAAGXktV3qvFr/0ljksE7fo0rWHxhrdocAAIAABHf143Pyy27w1GwGA2jtymHpwWDqxV/qyVyTeFrrwFflwFPislP+xVLpsErbmUfVkEbysETemUTpgj7ThT3XdTg5FDjdhTXWZTDaTCm7TCbTOCLXPiD9LA/QFg3UAwnOAQOEj5kcPpdyhZSptJEACJFpfo4AG44XMInFvYfTvIejmYSVkINyeoJzdoK9un6SjX7FrnwAEHp8enny2HjWwHjKtnhcX3jYzHeNhnfu2HWUjHWsonPNwnH70m9WTm8AAW//723pym3dtmn/0mbnxGa0o2ZeWWb8zGT/4mPtwmJuYmL/22D/vmB5ZGC9kF7/2l0MAF3uyFqnjVn4xFjYnli0mVi5i1jiqVfyyVbmtlbXkVNUOFPlvFLpt1LNrFKjfVLuvlBgHlDsuU/ouU9ONU/ov05ODk7/2E02Gk3jqkqEaUr/tUngjkf7n0bXikb6xERCJETdn0LckUG1gD/ooD3Ulj3jkz3TZT3WjjzOeDqBWDr3pDnglTlMADnbbTf2gjbkbzaTYDZpAjbplzTtcTTEazPXXzOeXzDscS3MPi38jizJWSrVSCrrXynzfCjVdCjZRyjTQCbFUiTlYCPXPSHLPSHWMR/wXh7iRh7GPh3PLBrSIRrWGhfMJxPGJxPRDBG/ABG2ABCxDg7BDAvEGArZAAbJAALPAADa4ry/AAAAPnRSTlMACEIaxqxpAvv7+ff19PDs7Ovn5uXk5OHg29LRy8fEw8G+vLqysaufnJiVk4yDfG9dXFpMSEFBNTApJyEcFO3QiBQAAAFzSURBVBjTYoACZjYZaTZmBmRgxsp9+di21ZysxggxxlmJZy/ev9LXnriIEa5VYUPIray0lOyd+ctVoKKWXFsmXXvu8exO5vsZnnuErcCC5m1e8x5nPXrxOu3TzSqHFguQmI18tff+Jx89HqR7fE5v7q5TtAYK6h8v81p4Ovv6wbAdmRc6HMpddYGCmudrCqbtTn2anHBq15SZ9iUx6kBBkSTfXIfUuBsPL909c9i/uP6EJFAQMJ6j2/Ps32Yk30uIy3jjXxgRLwEUVN07ubTo5LsPr16mXD1X29gZrgUUlN23uD/H28lp09o5TvYVs523ygEFORYsO+TbEOI5cVVTV+XUA1Fu/EBBoxXu0bfnT98cEePa45oUHR7MBHK9IV9Y/BFHFzc7R7/YqF4BsBiDqVBw0NLQoMAAF3c7vwmCEEFln1ZnZxe3wJWx7nZ2jj5qkNDU5l2/ZE3kusjQuRsDxPXYoQFqa6DBIiUmyqKkYwIWAgD35oZAL/mkFwAAAABJRU5ErkJggg=="
              alt=""
            />
            ©2024 Halo All Rights Reserved 杭州柚米科技有限公司 </a
          ><a href="https://beian.miit.gov.cn/#/Integrated/index"
            >浙ICP备2024055860号-1</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { onMounted } from "vue";
import { useRouterStore } from "@/stores/router";
export default {
  name: "FooterIndex",
  setup() {
    const router = useRouter();
    const routerStore = useRouterStore();
    const { setRouterName } = routerStore;

    onMounted(() => {
      let dl = document.querySelectorAll(".sys-ft-nav-wp dl");
      for (let i = 0; i < dl.length; i++) {
        dl[i].onclick = function () {
          this.classList.toggle("sys-dl-show");
        };
      }
    });

    const getRouter = (path) => {
      setRouterName(path);
      router.push(path);
    };

    const goSolution = (index) => {
      setRouterName("/#section2");
      router.push({
        path: "/",
        hash: "#section2",
        query: { solution: String(index) },
      });
    };

    return {
      router,
      routerStore,
      getRouter,
      goSolution,
    };
  },
};
</script>

<style lang="scss">
.sys-ft {
  position: relative;
  color: #999;
  background: url("@/assets/images/main/footer.png") no-repeat top center;
  background-size: 100% auto;
  min-height: 550px;
  margin: 0 auto;
  font-size: 14px;
  .sys-main {
    padding: 30px 20px 20px;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    padding: 0 260px;
    top: 280px;
    .sys-ft-left-wp {
      display: flex;
      position: absolute;
      top: -200px;
      .sys-ft-intro {
        padding-right: 50px;
        img {
          width: 38px;
          height: 28px;
          display: inline-block;
          margin-top: -10px;
          margin-right: 4px;
        }
        h2 {
          font-weight: 600;
          font-size: 24px;
          display: inline-block;
          color: #fff;
        }
        p {
          font-size: 14px;
          color: #fff;
          margin-top: 8px;
        }
        a {
          width: 92px;
          height: 28px;
          display: inline-block;
          border-radius: 16px;
          font-size: 14px;
          color: #fff;
          line-height: 24px;
          text-align: center;
          margin-top: 30px;
          text-decoration: none;
          background: linear-gradient(90deg, #0086ff 0%, #0b4bff 69.23%);
        }
        .btn-box {
          cursor: pointer;
          box-sizing: border-box;
          padding: 1px 10px;
          vertical-align: middle;
        }
      }

      .sys-ft-intro-PC {
        display: inline-block;
      }
      .sys-footer-codebox {
        font-size: 13px;
        margin-top: 10px;
        list-style: none;
        .codebox-PC {
          display: inline-block;
          vertical-align: top;
          box-sizing: border-box;
          margin-right: 20px;
          color: #999;
          text-align: center;
          img {
            margin: 0 auto 10px;
            width: 112px;
            height: 112px;
            display: block;
            border: 0;
          }
          p {
            width: 106px;
            height: 18px;
            background: #fff;
            border-radius: 9px;
            font-weight: 400;
            font-size: 12px;
            color: #181a1e;
            margin-left: 3px;
          }
        }
      }
      .sys-footer-codebox li:last-child {
        margin-right: 0;
      }
      .codebox-H5 {
        display: none;
        img {
          margin: 0 auto 10px;
          width: 112px;
          height: 112px;
        }
        p {
          width: 106px;
          height: 18px;
          background: #fff;
          border-radius: 9px;
          font-weight: 400;
          font-size: 12px;
          color: #181a1e;
          margin-left: 3px;
        }
      }
    }
    .sys-ft-info {
      position: relative;
      border-bottom: 1px solid #444;
      .sys-ft-intro {
        padding-right: 50px;
        h2 {
          font-weight: 600;
          font-size: 24px;
          display: inline-block;
          color: #fff;
        }
        p {
          font-size: 14px;
          color: #fff;
          margin-top: 8px;
        }
        a {
          width: 92px;
          height: 28px;
          display: inline-block;
          background: #fff;
          border-radius: 16px;
          font-size: 14px;
          color: #3b3f46;
          line-height: 24px;
          text-align: center;
          margin-top: 30px;
          text-decoration: none;
        }
        .btn-box {
          vertical-align: middle;
          box-sizing: border-box;
          padding: 1px 10px;
          border: 1px solid #fff;
          cursor: pointer;
        }
      }
      .sys-ft-intro-H5 {
        display: none;
      }
      .sys-ft-nav-wp {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .logo {
          width: 63px;
          height: 63px;
        }
        dl {
          display: inline-block;
          vertical-align: top;
          margin-left: 62px;
          line-height: 30px;
          dt {
            margin-bottom: 10px;
            font-size: 14px;
            color: #fff;
            font-weight: 600;
          }
          dd {
            font-size: 12px;
            a {
              outline: none;
              text-decoration: none;
              color: #fff;
              cursor: pointer;
            }
          }
        }
      }
    }
    // .sys-ft-info::after {
    //   position: absolute;
    //   left: 53%;
    //   top: 8px;
    //   bottom: 0;
    //   width: 1px;
    //   height: 144px;
    //   content: "";
    //   background-color: #444;
    // }
    .sys-ft-rights {
      margin-top: 25px;
      font-size: 12px;
      color: #71757b;
      display: flex;
      justify-content: center;
      a {
        text-decoration: none;
        color: #71757b;
        img {
          display: inline-block;
          height: 18px;
          width: 18px;
          vertical-align: text-top;
          margin-right: 3px;
        }
      }

      .first-beian {
        margin-right: 4px;
      }
      .last-beian {
        margin-left: 60px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}
// 适配移动端
@media screen and (max-width: 768px) {
  .sys-main {
    padding-left: 16px;
    padding-right: 16px;
  }
  .sys-ft {
    background: #000;
    background-size: initial;
    min-height: auto;
    min-width: 100%;
    .sys-main {
      width: 100%;
      padding: 40px 20px;
      top: 0;
      .sys-ft-left-wp {
        display: none;
      }
      .sys-ft-info {
        position: relative;
        display: block;
        padding-bottom: 0px;
        margin: 0px -20px;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        .sys-ft-intro-H5 {
          display: inline-block;
          text-align: center;
          width: 100%;
          padding-right: 0px;
          .sys-ft-intro h2 {
            font-weight: 600;
            font-size: 24px;
            display: inline-block;
            color: rgb(255, 255, 255);
          }
        }
        .sys-ft-left-wp {
          display: block;
          .sys-footer-codebox {
            display: flex;
            position: static;
            text-align: center;
            width: 100%;
            margin: 30px auto 10px;
            font-size: 12px;
            padding-left: 20px;
            .codebox-PC {
              display: none;
            }
            .codebox-H5 {
              display: flex;
              background: #fff;
              margin-right: 20px;
              img {
                width: 100px;
                height: 100px;
                margin: 10px 5px;
              }
              p {
                line-height: 14px;
                width: 16px;
                height: 90px;
                background: #fff;
                color: #000;
                border-radius: 9px;
                font-weight: 400;
                font-size: 10px;
                margin-right: 8px;
                margin-top: 24px;
              }
              .codebox-H5-p-black {
                height: 90px;
                background: #000;
                color: #fff;
                margin-right: 4px;
                margin-top: 28px;
              }
            }
          }
        }
        .sys-ft-nav-wp {
          width: auto;
          display: block;
          justify-content: initial;
          position: relative;
          top: 40px;
          padding-bottom: 40px;
          .logo {
            display: none;
          }
          dl {
            position: relative;
            display: block;
            max-height: 50px;
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            transition: max-height 2s;
            margin: 0;
            dt {
              position: relative;
              margin-bottom: 0;
              padding: 0 20px;
              font-size: 14px;
              color: #fff;
              font-weight: 600;
            }
            dt:after {
              position: absolute;
              bottom: 0;
              height: 1px;
              content: "";
              background: #cacdd0;
              transform: scaleY(0.5);
              transform-origin: center bottom;
              left: 20px;
              right: 20px;
              background-color: #41444a;
            }
            dd {
              padding: 0 20px;
              background-color: #333;
              font-size: 12px;
              margin: 0;
              a {
                color: #fff;
              }
            }
          }
          dl.sys-dl-show {
            height: auto;
            max-height: 600px;
          }
          dl:before {
            position: absolute;
            right: 20px;
            top: 24px;
            width: 13px;
            height: 1px;
            content: "";
            background-color: #999;
          }
          dl:after {
            position: absolute;
            right: 20px;
            top: 24px;
            width: 13px;
            height: 1px;
            content: "";
            background-color: #999;
            transform: rotate(90deg);
            transition:
              transform 0.3s,
              -webkit-transform 0.3s;
          }
        }
      }
      .sys-ft-info::after {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .sys-ft {
    min-width: 100%;
    .sys-main {
      width: 100%;
      padding-left: 40px;
      padding-right: 40px;
    }
  }
}
@media screen and (max-width: 576px) {
  .sys-ft {
    min-width: 100%;
    .sys-main {
      width: 100%;
      .sys-ft-rights {
        div {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
</style>
